export default {
  newPassword: "",
  oldPassword: "",
  confirmNewPassword: "",
};
